import { lazy } from 'react';

// ----------------------------------------------------------------------

const InsurancePage = lazy(() => import('../pages/Insurance.page'));

// ----------------------------------------------------------------------

const InsuranceRoutes = [
    {
        path: '/self-services/insurance',
        element: <InsurancePage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { InsuranceRoutes };
